// Romanian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `Disponibil până la ${date}` : ''),
    },
    interview: {
      title: 'Răspundeți interviului video',
      submit: 'Trimiteți răspusurile și încheiați interviul',
      continueLater: 'Continuă mai târziu',
      startInterview: 'Începe interviul',
      duplicateError: 'Ați participat deja la acest interviu. Ați primit un e-mail de la invitations@recright.com care conține un link care vă permite să continuați interviul.',
      confirmSubmitHeader: 'Nu ați răspuns la toate răspunsurile din interviu',
      confirmSubmitContent: 'Sunteți sigur că doriți să finalizați interviul?',
      confirmSubmitContentWarning: 'După aceea, nu veți mai putea să completați răspunsurile.',
      submitInterviewHeader: 'Trimiteți răspunsurile la interviu',
      submitInterviewContent: 'Sunteți sigur că vreți să vă trimiteți interviul?',
      confirmSubmitButton: 'Trimiteți răspusurile și încheiați interviul',
      preview: 'Puteți pre-vizualiza întrebările video aici.',
      requiredQuestionsNotAnswered: 'Vă rugăm să răspundeți la toate întrebările obligatorii înainte de a trimite.',

      withdrawLink: 'Nu mai sunteți interesat(ă) de acest post? Retrageți-vă din proces aici.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Numele',
      city: 'Orașul natal',
      email: 'Email',
      phone: 'Număr telefon',
      link: 'Link',
      legendBasicInfo: 'Informații de bază',
      placeholderName: 'Introduceți numele dumneavoastră',
      placeholderEmail: 'Introduceți adresa dumneavoastră de e-mail',
      placeholderPhone: 'Introduceți numărul dumneavoastră de telefon',
      placeholderCity: 'Introduceți orașul actual de rezidență',
      placeholderLink: 'Adăugați un link, de exemplu pentru profilul dumneavoastră de Linkedin.',
      legendAttachments: 'Documente atașate',
      legendAdditionalFields: 'Informații suplimentare',
      required: 'Elementele marcate cu un * asterisc sunt obligatorii.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Da',
        no: 'Nu',
        supported: 'Compatibil',
        quality: 'Calitate',
        header: 'Testarea rețelei și a dispozitivului',
        description: 'Acum vom efectua o testare, pentru a ne asigura că echipamentul (camera și microfonul) și conexiunea la rețea necesare interviului funcționează corespunzător. Atunci când apare mesajul, vă rugăm să permiteți testării să utilizeze atât camera video, cât și microfonul, și să vă asigurați că imaginea camerei nu este obstrucționată. Testul va dura aproximativ 30 de secunde. Vă recomandăm să vorbiți în timpul testării dispozitivului.',
        inProgress: 'Testare în desfășurare...',
        networkTestResults: 'Rezultatele testării rețelei',
        qualityTestResults: 'Rezultatele testării de calitate',
        testPassedQuality: 'Testare de calitate promovată',
        testFailedQuality: 'Test de calitate eșuat',
        testPassedNetwork: 'Test rețea reușit',
        testFailedNetwork: 'Testare de rețea eșuată',
        startTest: 'Începere test',
        startInterview: 'Începere interviu',
        testAgain: 'Retestare',
        confirmWarning: 'Atunci când începe interviul video, vi se afișează automat prima întrebare. De îndată ce ați vizualizat întrebarea, veți trece la pregătirea răspunsului.',
        confirmTitle: 'Urmează să începeți interviul',
        confirmText: 'Aveți la dispoziție câteva momente pentru a vă pregăti înainte de a răspunde la fiecare întrebare. Odată pregătit răspunsul, aveți la dispoziție o perioadă prestabilită de timp pentru a răspunde la întrebare. Puteți trimite răspunsul de îndată ce ați terminat de vorbit, chiar și înainte ca timpul limită să fi expirat.',
        confirmText2: 'După ce trimiteți răspunsul, veți fi direcționat(ă) la următoarea întrebare, până când se termină toate întrebările.',
        confirmText3:
          'Vă rugăm să rețineți că, după ce ați înregistrat răspunsul la o întrebare, veți avea la dispoziție un interval de 30 de secunde pentru a relua acordarea răspunsului, dacă este permisă reacordarea răspunsului la întrebarea respectivă. Dacă nu inițiați reacordarea răspunsului în această perioadă de 30 de secunde, răspunsul dvs. actual va fi trimis automat și veți fi direcționat la următoarea întrebare.',
        goodLuck: 'Respirați adânc și totul va fi bine. Succes!',
        qualityRating: {
          excellent: 'Excelent',
          good: 'Bun',
          fair: 'Mediu',
          poor: 'Slab',
          bad: 'Foarte slab',
        },
      },
      questionAnswerView: {
        title: title => `Răspuns la interviul ${title}`,
        question: 'Întrebare',
        submitAndNext: 'Trimitere și următoarea',
        submitSuccess: 'Video trimis cu succes!',
        skipText: 'Începere înregistrare',
        stop: 'Oprire',
        submitAndFinish: 'Transmiteți & Încheiați interviul',
        retake: 'Reluați',
        take: 'Încercare',
        takesLeft: 'Încercări rămase',
        skipTextQuestion: 'Gata? Continuă',
        retakeConfirmTitle: 'Sigur doriți să reluați acordarea răspunsului la această întrebare?',
        retakeConfirmSubmit: 'Da, reacordați răspunsul',
        submitInfoForward: 'Trimitere automată a răspunsului actual și avansarea în',
        submitInfoForward2: 'secunde',
        nonAnswerableText: 'Acest mesaj nu necesită răspuns. După acest mesaj, veți fi direcționat direct la următoarea întrebare.',
        nonAnswerableVideo: 'Acest mesaj nu necesită răspuns. După acest videoclip, veți fi direcționat direct la următoarea întrebare.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Aveți la dispoziție ${answerMinutes} minute și ${answerSeconds} secunde pentru a răspunde la întrebare.`,
      },
      publisher: {
        toNextQuestion: timer => `Direcționare la următoarea întrebare în ${timer}`,
        recordingStarts: timer => `Înregistrarea începe în ${timer}`,
      },
      errors: {
        tooManyConnections: 'Această conexiune a fost întreruptă pentru că aveți deja o altă pagină deschisă în alt tab sau într-o altă fereastră.',
        unsupportedBrowser: 'Din păcate, această operațiune nu poate fi efectuată în browserul dvs. Vă rugăm să utilizați un alt browser.',
        networkError: 'Nu există conexiune la internet.',
        reconnecting: 'Conexiunea a fost întreruptă. Se încearcă reconectarea.',
        generalError: 'Ceva nu a mers bine. Vă rugăm să reîncărcați pagina și să încercați din nou.',
        allowMediaDevicesError: 'Această operațiune nu a putut găsi dispozitivele media (cameră sau microfon). Vă rugăm să vă asigurați că ați permis browserului să utilizeze microfonul și camera.',
        noAvailableDevicesError: 'Nu am reușit să găsim camera sau microfonul.',
        initPublisherError: 'Operațiunea a eșuat din cauza unei erori. Asigurați-vă că ați permis browserului să utilizeze camera video și microfonul și că acestea nu sunt utilizate de o altă aplicație și încercați din nou.',
      },
      browserInfo: {
        browserSupportTitle: 'Compatibilitate browser',
        supportedBrowsers: 'Această testare și acest interviu sunt compatibile cu cele mai recente versiuni ale Chrome, Firefox, Safari și Edge.',
        mobileSupported: 'Browsere compatibile pe mobil',
        android: 'Android: Google Chrome (cea mai recentă versiune), Firefox (cea mai recentă versiune)',
        iOS: 'iOS: Safari (cea mai recentă versiune)',
        latestVersion: 'Vă rugăm să vă asigurați că utilizați cea mai recentă versiune a browserului, pentru a ne asigura că totul funcționează corespunzător.',
        freezeInstruction: 'Dacă videoclipul nu pornește sau dacă ecranul rămâne negru vă rugăm să reîncărcați pagina.',
        unsupportedOnIos: 'Se pare că utilizați un browser necompatibil pe iOS. Vă rugăm să utilizați Safari.',
        ieUnsupported: 'Se pare că utilizați Internet Explorer. Din păcate, Internet Explorer nu este compatibil cu acest test sau cu acest interviu. Vă rugăm să utilizați un alt browser.',
        qualityTestNotSupported: 'Din păcate, testarea dispozitivului nu este compatibilă cu browserul pe care îl utilizați. Puteți continua către interviu fără să testați calitatea audio și video sau puteți să utilizați un alt browser.',
      },
      reconnectSuccess: 'Reconectare reușită!',
      continue: 'Continuare',
    },

    withdraw: {
      title: 'Nu mai sunteți interesat(ă) de acest post?',
      description: 'Retrageți-vă din procesul de recrutare.',
      buttonText: 'Retragere din procesul de recrutare',
      thankYouTitle: 'Vă mulțumim!',
      thankYouText: 'Ați informat persoanele responsabile de recrutare că acest post nu vă mai interesează.',
      confirm: 'Confirmați că doriți să vă retrageți din procesul de recrutare? După retragere nu veți mai putea participa la acest interviu și nici la altele legate de acest post.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Trimitere',
      continue: 'Continuare',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Vă mulțumim pentru răspunsul video! Vă vom contacta în curând!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Vă mulțumim pentru participarea la interviu!',
      reopenDescription: 'Dacă ai închis interviul din greșeală, nu îți face griji! Poți redeschide interviul apăsând butonul de mai jos!',
      reopenButtonText: 'Redeschidere interviu',
      description1: 'Minunat, ai răspuns la toate întrebările, iar raspunsurile au fost trimise destinatarului.',
      descriptionsupport: mailto => `Dacă ați închis acest interviu din greșeală, vă rugăm contactați serviciul clienți ${mailto} și vă vom re-deschide interviul.`,
      descriptionfeedback: 'Experiența dumneavoastră este importantă pentru noi! Cum a fost experiența de a răspunde unui interviu video? Cum ați îmbunătăți serviciul nostru? Vă rugăm lăsați-ne impresiile aici.',
      feedbackbutton: 'Împărtășiți-vă impresiile cu noi!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Mesaj privat',
    },

    closed: {
      title: 'Interviul este complet sau s-a terminat',
      description: 'Interviul video la care ați fost invitat s-a terminat sau ați trimis deja răspunsurile.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Interviul dumneavoastră video este salvat!',
      description: 'Atunci când doriți să continuați interviul video, folosiți linkul pe care l-ați primit pe e-mail. Răspunsurile video pe care le-ați înregistrat deja vor fi acolo când vă întoarceți! Mult succes în căutarea de locuri de muncă!',
      remember: 'Amintiți-vă să trimiteți răspunsurile persoanei care se ocupă de recrutare, atunci când ați terminat de răspuns la interviu.',
      deleteHistory: 'Dacă efectuați interviul video pe un calculator public, vă rugăm să nu uitați să ștergeți istoricul de navigare. Astfel, interviul dumneavoastră este în siguranță.',
    },
    unpublished: {
      title: 'Interviul nu este încă deschis.',
      publishTime: publishTime => `Interviul se va deschide la ${publishTime}`,
    },
  },
}
